import axios from 'axios';

if (jQuery('#map').length > 0) {
    const mymap = L.map('map').setView([46.566053, 3.33317], 6);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        maxZoom: 18,
        attribution: '',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        scrollWheelZoom: false
    }).addTo(mymap);
    mymap.scrollWheelZoom.disable();
    //L.tileLayer.provider('CartoDB.Positron').addTo(mymap);

    load_marker(mymap);

    jQuery('#btnsearchmap').click(function () {
        search_location(mymap);
    });
}

function load_marker(map)
{
    const myicon = L.icon({
        iconUrl: assets_url + 'images/cursor-map-mazet.png',
        iconSize:     [28, 40], // size of the icon
        iconAnchor:   [14, 40], // point of the icon which will correspond to marker's location
        popupAnchor:  [-250, 0] // point from which the popup should open relative to the iconAnchor
    });

    axios.get('/wp-json/getters/agences')
        .then(function (response) {
            // handle success
            const data = response.data;

            jQuery.each(data, function (i,v) {
                const marker = L.marker([v.latitude, v.longitude], {icon: myicon}).addTo(map);
                const html = html_markers(v);
                const options = {minWidth: 400, maxWidth : 500};
                marker.bindPopup(html, options);
            });
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
        });
}

function search_location(map)
{
    const search = jQuery('#searchmap').val();

    axios.post('/wp-json/getters/agences/search', {
        search: search
    })
        .then(function (response) {
            const latlng = response.data;
            map.flyTo(new L.LatLng(latlng.latitude, latlng.longitude), 8);
        })
        .catch(function (error) {
            console.log(error);
        });
}

function html_markers(item)
{
    let html = "<div class='marker'>";
    if (item.illustration) {
        html += "<div class='illu'><img src='" + item.illustration + "' alt='' title='' class='img-fluid' /></div>";
    }
        html += "<div class='content'>";
            html += "<span class='titre'>" + item.titre + "</span>";
            html += "<span class='adresse'>" + item.adresse + "<br />" + item.cp + " " + item.ville + "</span>";
    if (item.telephone) {
        html += "<span class='contact'><b>Téléphone :</b> " + item.telephone + "</span>";
    }
    if (item.fax) {
        html += "<span class='contact'><b>Fax :</b> " + item.fax + "</span>";
    }
    if (item.email) {
        html += "<span class='contact'><b>Email :</b> " + item.email + "</span>";
    }
        html += "</div>";
    html += "</div>";

    return html;
}


// WEBPACK FOOTER //
// ./src/js/app/map.js